import { useDebouncedCallback as useMantineDebouncedCallback } from '@mantine/hooks';

export const useDebouncedCallback = useMantineDebouncedCallback;
